import styled from 'styled-components';
import DetailSummary from './DetailSummary';
import CampaignCosts from './CampaignCosts';
import StationSplit from './StationSplit';
import PeakPercentage from './PeakPercentage';
import DayStrat from './DayStrat';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import mapDemographics from '../../util/mapDemographics';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  margin-bottom: 16px;
  margin-top: 16px;
`;

const Header = styled.h2`
  margin-bottom: 16px;
  margin-top: 16px;
`;

const CampaignOverview = () => {
  const {
    agencyName,
    advertiserName,
    campaignName,
    advertiserDiscount,
    demographic
  } = useAppSelector((state: RootState) => state.detail);

  const details = [
    { title: 'Agency', content: agencyName },
    { title: 'Discount', content: (advertiserDiscount * 100).toString() + '%' },
    { title: 'Advertiser', content: advertiserName },
    { title: 'Campaign Name', content: campaignName }
  ];

  return (
    <div>
      <Header>Campaign Overview</Header>
      <StyledContainer>
        <DetailSummary heading="Campaign Details" details={details} />
        {demographic && (
          <DetailSummary
            heading="Demographics"
            details={mapDemographics(demographic)}
          />
        )}
      </StyledContainer>
      <CampaignCosts />
      <StyledContainer>
        <StationSplit />
        <PeakPercentage />
      </StyledContainer>
      <DayStrat />
    </div>
  );
};

export default CampaignOverview;
